<template lang="html">
    <li class="main-menu__item">
        <router-link v-bind:to="{ name: 'Logs'}" v-bind:class="{[settingsLinkActiveClass]: (settingLink == 'Logs')}">
            <span>История</span>
        </router-link>
    </li>
</template>
<script>
    export default {
        name: 'logs-settings-menu',
        sort: 11,
        module: 'logger',
        data() {
            return {
                sort: 11,
                module: 'logger'
            }
        },
        computed: {
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SettingsMenu.vue?738d02be